import React, { useEffect, useState } from "react";
import Input from "../Common/CustomInput";
import CustomSelect from "../Common/CustomSelect";
import api from "../../setupMiddleware";
import Loader from "../Loader/Loader";
import useApiLoader from "../../Utils/useApiLoader";
import { ToastContainer, toast, Bounce } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import FileUpload from "../Common/FileUpload";
import { createFormData, getCountryList } from "../../Utils/getUserUtitls";
import Textarea from "../Common/Textarea";
import { FiEdit } from "react-icons/fi";
import Popup from "../Common/Popup";
import { useLayout } from "./LayoutContext";

const EmployeeDetails = () => {
  const navigate = useNavigate();
  const loading = useApiLoader();
  const [roleData, setRoleData] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [gradeData, setGradeData] = useState([]);
  const [tlData, setTlData] = useState([]);
  const [hrData, setHrData] = useState([]);
  const [managerData, setManagerData] = useState([]);
  const [sameAddress, setSameAddress] = useState(false);
  const [editImage, setEditImage] = useState(false);
  const [noUserOpen, setNoUserOpen] = useState(false);
  const [apiErrorOpen, setApiErrorOpen] = useState(false);
  const { layoutRef } = useLayout();
  const [errorMessage, setErrorMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const { id } = useParams();

  const designationOptions = designationData?.map((des) => ({
    label: des.title,
    value: des.id,
  }));

  const roleOptions = roleData?.map((ro) => ({
    label: ro.name,
    value: ro.id,
  }));

  const departmentOptions = departmentData?.map((dep) => ({
    label: dep.name,
    value: dep.id,
  }));

  const locationOptions = locationData?.map((loc) => ({
    label: loc.name,
    value: loc.id,
  }));

  const gradeOptions = gradeData?.map((grd) => ({
    label: grd.title,
    value: grd.id,
  }));

  const tlOptions = tlData?.map((tl) => ({
    label: tl.first_name + " " + tl.last_name,
    value: tl.id,
  }));

  const hrOptions = hrData?.map((hr) => ({
    label: hr.first_name + " " + hr.last_name,
    value: hr.id,
  }));

  const managerOptions = managerData?.map((mr) => ({
    label: mr.first_name + " " + mr.last_name,
    value: mr.id,
  }));

  const genderOptions = [
    {
      label: "Male",
      value: "male",
    },
    {
      label: "Female",
      value: "female",
    },
    {
      label: "Other",
      value: "other",
    },
  ];

  const maritalStatusOptions = [
    {
      label: "Single",
      value: "Single",
    },
    {
      label: "Married",
      value: "Married",
    },
    {
      label: "Separated/Divorced",
      value: "Separated/Divorced",
    },
  ];

  const nationalityOptions = getCountryList();

  const [employee, setEmployee] = useState();
  const [currentAddress, setCurrentAddress] = useState("");

  const getUserById = async () => {
    try {
      await api.get(`/api/user/${id}`).then((res) => {
        if (res && res.status === 200) {
          setEmployee(res.data?.data);
          setCurrentAddress(res.data?.data?.current_address);
          getAllData();
          // getAllDesignations();
          // getAllDepartments();
          getAllLocation();
          // getAllGrades();
          // getAllTeamLeaders();
        }
      });
    } catch (error) {
      if (error?.response?.data?.message == "User not found.") {
        setNoUserOpen(true);
      } else {
        setApiErrorOpen(true);
      }
    }
  };

  const getAllData = async () => {
    api.get("/api/master-data").then((res) => {
      if (res && res.status === 200) {
        const resData = res.data?.data;
        const filteredRoleData = resData?.roles.filter((item) => {
          // Always remove id=1
          if (item.id === 1) return false;

          // If logged-in user is NOT 1, also remove id=2
          if (id !== 1 && item.id === 2) return false;

          return true; // keep everything else
        });
        setRoleData(filteredRoleData);
        setDesignationData(resData?.designations);
        setDepartmentData(resData?.departments);
        // setLocationData(resData?.data);
        setGradeData(resData?.grades);
        setTlData(resData?.team_leaders);
        setHrData(resData?.hrs);
        setManagerData(resData?.managers);
      }
    });
  };

  // const getAllDesignations = async () => {
  //   try {
  //     api.get("/api/designations").then((res) => {
  //       if (res && res.status === 200) {
  //         setDesignationData(res.data);
  //       }
  //     });
  //   } catch (error) {
  //     setApiErrorOpen(true);
  //   }
  // };

  // const getAllDepartments = async () => {
  //   try {
  //     api.get("/api/departments").then((res) => {
  //       if (res && res.status === 200) {
  //         setDepartmentData(res.data);
  //       }
  //     });
  //   } catch (error) {
  //     setApiErrorOpen(true);
  //   }
  // };

  const getAllLocation = async () => {
    try {
      api.get("/api/locations").then((res) => {
        if (res && res.status === 200) {
          setLocationData(res.data?.data);
        }
      });
    } catch (error) {
      setApiErrorOpen(true);
    }
  };

  useEffect(() => {
    if (id == 1) {
      window.location = "/employees";
    }
    getUserById();
  }, []);

  const handleUpdateEmployee = async () => {
    // if (
    //   !employee?.username ||
    //   !employee?.first_name ||
    //   !employee?.last_name ||
    //   !employee?.email ||
    //   !employee?.joining_date ||
    //   !employee?.gender ||
    //   !employee?.designation_id ||
    //   !employee?.role_id ||
    //   !employee?.department_id ||
    //   !employee?.grade_id ||
    //   !employee?.location_id
    // ) {
    //   alert("Please fill all the data to add employee!");
    //   return;
    // }

    try {
      const formData = createFormData(employee);
      console.log(formData);
      await api.post(`/api/update-employee/${id}`, formData).then((res) => {
        if (res && res.status === 200) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          navigate("/employees");
        }
      });
    } catch (err) {
      if (err) {
        toast.error(err.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
      }
    }
  };

  console.log("currentAddress", currentAddress);

  const handleSameAddress = () => {
    if (!sameAddress) {
      setEmployee({
        ...employee,
        current_address: employee?.permanent_address,
      });
      setSameAddress(!sameAddress);
    } else {
      setEmployee({ ...employee, current_address: currentAddress });
      setSameAddress(!sameAddress);
    }
  };

  useEffect(() => {
    if (errorMessage && layoutRef.current) {
      layoutRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [errorMessage]);

  // automatically clear error after 5 seconds
  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 5000); // 5s

      // cleanup if message changes before 5s
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);
  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Employee Details
          </span>
          <span className="block text-sm text-[#142b70]/50">
            View/Update All the Employee Details
          </span>
        </p>
      </div>
      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto p-8 relative rounded-3xl bg-white border border-[#a48572]/10">
          {errorMessage && (
            <div className="mb-4 w-full rounded-lg bg-red-50 border border-red-400 text-red-700 px-4 py-2">
              {errorMessage}
            </div>
          )}
          <div className="flex flex-col lg:flex-row flex-grow justify-start items-start gap-[60px]">
            {/* Form Col 1*/}
            <div className="flex flex-col flex-grow gap-6 w-full">
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <div className="relative">
                    {!editImage ? (
                      <div
                        className="w-40 h-40 rounded-full mx-auto mb-8 overflow-hidden relative cursor-pointer"
                        onClick={() => setEditImage(true)}
                      >
                        <img
                          src={employee?.employee_image}
                          className="w-40 h-40 object-cover"
                        />
                        <div className="w-40 h-40 z-10 bg-[#142b70]/50 absolute top-0 left-0"></div>
                        <FiEdit className="z-20 text-white text-[20px] absolute top-[calc(50%-10px)] left-[calc(50%-10px)]" />
                      </div>
                    ) : (
                      <FileUpload
                        label="Profile Photo"
                        accept="image/*"
                        multiple={true}
                        onChange={(file) =>
                          setEmployee({ ...employee, employee_image: file })
                        }
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">First Name</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter First name"
                      value={employee?.first_name}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          first_name: e.target.value,
                        })
                      }
                      error={!employee?.first_name && submitted}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Middle Name</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Middle name"
                      value={employee?.middle_name}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          middle_name: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Last Name</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Last name"
                      value={employee?.last_name}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          last_name: e.target.value,
                        })
                      }
                      error={!employee?.last_name && submitted}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Father Name</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Father Name"
                      value={employee?.father_name}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          father_name: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Mother Name</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Mother Name"
                      value={employee?.mother_name}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          mother_name: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Username</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Username"
                      value={employee?.username}
                      onChange={(e) =>
                        setEmployee({ ...employee, username: e.target.value })
                      }
                      error={!employee?.username && submitted}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Personal Email</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Email"
                      value={employee?.email}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          email: e.target.value,
                        })
                      }
                      error={!employee?.email && submitted}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Office Email</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Office Email"
                      value={employee?.office_email}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          office_email: `${e.target.value}`,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Emergency Contact</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Emergency Contact"
                      value={employee?.emergency_contact}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          emergency_contact: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Phone Number</p>
                  <div className="relative">
                    <Input
                      type="number"
                      placeholder="Enter Phone Number"
                      value={employee?.phone}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          phone: `${e.target.value}`,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Date of Birth</p>
                  <div className="relative">
                    <Input
                      type="date"
                      placeholder="Enter DOB"
                      value={employee?.dob}
                      onChange={(e) =>
                        setEmployee({ ...employee, dob: e.target.value })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Date of Joining</p>
                  <div className="relative">
                    <Input
                      type="date"
                      placeholder="Enter Date of Joining"
                      value={employee?.joining_date}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          joining_date: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Gender</p>
                  <div className="relative">
                    <CustomSelect
                      options={genderOptions}
                      value={employee?.gender}
                      placeholder="Gender"
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      onChange={(op) =>
                        setEmployee({
                          ...employee,
                          gender: op.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Place of Birth</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Place of Birth"
                      value={employee?.place_of_birth}
                      onChange={(e) =>
                        setEmployee({
                          ...employee,
                          place_of_birth: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Marital Status</p>
                  <div className="relative">
                    <CustomSelect
                      options={maritalStatusOptions}
                      value={employee?.marital_status}
                      placeholder="Marital Status"
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      onChange={(op) =>
                        setEmployee({
                          ...employee,
                          marital_status: op.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-2 w-full">
                <p className="text-sm text-[#142b70]/80">Relieving Date</p>
                <div className="relative">
                  <Input
                    type="date"
                    placeholder="Enter Relieving Date"
                    value={employee?.leaving_date}
                    onChange={(e) =>
                      setEmployee({
                        ...employee,
                        leaving_date: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            {/* Form Col 2 */}
            <div className="flex flex-col flex-grow gap-6 w-full">
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Role</p>
                  <CustomSelect
                    options={roleOptions}
                    value={employee?.role_id}
                    placeholder="Role"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) =>
                      setEmployee({
                        ...employee,
                        role_id: op.value,
                      })
                    }
                    error={!employee?.role_id && submitted}
                  />
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Designation</p>
                  <CustomSelect
                    options={designationOptions}
                    value={employee?.designation_id}
                    placeholder="Designation"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) =>
                      setEmployee({
                        ...employee,
                        designation_id: op.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Grade</p>
                  <CustomSelect
                    options={gradeOptions}
                    value={employee?.grade_id}
                    placeholder="Grade"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) =>
                      setEmployee({
                        ...employee,
                        grade_id: op.value,
                      })
                    }
                    error={!employee?.grade_id && submitted}
                  />
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Department</p>
                  <CustomSelect
                    options={departmentOptions}
                    value={employee?.department_id}
                    placeholder="Department"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) =>
                      setEmployee({
                        ...employee,
                        department_id: op.value,
                      })
                    }
                    error={!employee?.department_id && submitted}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                {employee?.role_id === 3 ? (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">HR Head</p>
                    <CustomSelect
                      options={hrOptions}
                      value={employee?.hr_head}
                      placeholder="HR Head"
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      onChange={(op) =>
                        setEmployee({
                          ...employee,
                          hr_head: op.value,
                        })
                      }
                    />
                  </div>
                ) : employee?.role_id === 4 ? (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Manager</p>
                    <CustomSelect
                      options={managerOptions}
                      value={employee?.manager}
                      placeholder="Manager"
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      onChange={(op) =>
                        setEmployee({
                          ...employee,
                          manager: op.value,
                        })
                      }
                    />
                  </div>
                ) : employee?.role_id === 8 ? (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Team Leader</p>
                    <CustomSelect
                      options={tlOptions}
                      value={employee?.tl_id}
                      placeholder="Team Leader"
                      width="w-full"
                      height="h-[46px]"
                      fontSize="14px"
                      disable={employee?.role_id !== 8}
                      onChange={(op) =>
                        setEmployee({
                          ...employee,
                          tl_id: op.value,
                        })
                      }
                    />
                  </div>
                ) : (
                  <></>
                )}
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">HR</p>
                  <CustomSelect
                    options={hrOptions}
                    value={employee?.hr_id}
                    placeholder="HR"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) =>
                      setEmployee({
                        ...employee,
                        hr_id: op.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Job Location</p>
                  <CustomSelect
                    options={locationOptions}
                    value={employee?.location_id}
                    placeholder="Job Location"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) =>
                      setEmployee({
                        ...employee,
                        location_id: op.value,
                      })
                    }
                  />
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Nationality</p>
                  <CustomSelect
                    options={nationalityOptions}
                    value={employee?.nationality}
                    placeholder="Nationality"
                    width="w-full"
                    height="h-[46px]"
                    fontSize="14px"
                    onChange={(op) =>
                      setEmployee({
                        ...employee,
                        nationality: op.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Salary</p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Salary amount"
                      value={employee?.salary}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          salary: `${e.target.value}`,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">
                    Employee Personal Number
                  </p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Employee Personal Number"
                      value={employee?.employee_personal_number}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          employee_personal_number: `${e.target.value}`,
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">
                    Bank Account Number
                  </p>
                  <div className="relative">
                    <Input
                      type="text"
                      placeholder="Enter Bank Account Number"
                      value={employee?.bank_account_number}
                      onChange={(e) => {
                        setEmployee({
                          ...employee,
                          bank_account_number: `${e.target.value}`,
                        });
                      }}
                    />
                  </div>
                </div>
                {employee?.location_id === 2 ? (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Bank IFSC Code</p>
                    <div className="relative">
                      <Input
                        type="text"
                        placeholder="Enter Bank IFSC Code"
                        value={employee?.ifsc_code}
                        onChange={(e) => {
                          setEmployee({
                            ...employee,
                            ifsc_code: `${e.target.value}`,
                          });
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">
                      Bank Routing Code
                    </p>
                    <div className="relative">
                      <Input
                        type="text"
                        placeholder="Enter Bank Routing Code"
                        value={employee?.bank_routing_code}
                        onChange={(e) => {
                          setEmployee({
                            ...employee,
                            bank_routing_code: `${e.target.value}`,
                          });
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="flex justify-between gap-5">
                {employee?.location_id === 1 && (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Emirates ID</p>
                    <div className="relative">
                      <Input
                        type="text"
                        placeholder="Enter your Emirates ID"
                        value={employee?.emirate_id}
                        onChange={(e) => {
                          setEmployee({
                            ...employee,
                            emirate_id: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                )}
                {employee?.location_id === 2 ? (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Adhaar Number</p>
                    <div className="relative">
                      <Input
                        type="text"
                        placeholder="Enter Adhaar Number"
                        value={employee?.adharcard_no}
                        onChange={(e) => {
                          setEmployee({
                            ...employee,
                            adharcard_no: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col gap-2 w-full">
                    <p className="text-sm text-[#142b70]/80">Passport Number</p>
                    <div className="relative">
                      <Input
                        type="text"
                        placeholder="Enter Passport Number"
                        value={employee?.passport_no}
                        onChange={(e) => {
                          setEmployee({
                            ...employee,
                            passport_no: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Permanent Address</p>
                  <Textarea
                    value={employee?.permanent_address}
                    placeholder="Permanent Address"
                    onChange={(e) => {
                      sameAddress
                        ? setEmployee({
                            ...employee,
                            permanent_address: e.target.value,
                            current_address: e.target.value,
                          })
                        : setEmployee({
                            ...employee,
                            permanent_address: e.target.value,
                          });
                    }}
                    rows={4}
                  />
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <label className="flex items-center gap-2 cursor-pointer text-sm text-[#142b70]/80">
                    <input
                      type="checkbox"
                      checked={sameAddress}
                      onChange={handleSameAddress}
                      className="h-4 w-4 accent-[#a48572] cursor-pointer"
                    />
                    Current address is same as Permanent address.
                  </label>
                </div>
              </div>
              <div className="flex justify-between gap-5">
                <div className="flex flex-col gap-2 w-full">
                  <p className="text-sm text-[#142b70]/80">Current Address</p>
                  <Textarea
                    value={employee?.current_address}
                    placeholder="Current Address"
                    disable={sameAddress}
                    onChange={(e) =>
                      setEmployee({
                        ...employee,
                        current_address: e.target.value,
                      })
                    }
                    rows={4}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Footer */}
          <div className="flex justify-end gap-4 mt-8">
            <button
              className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium"
              onClick={handleUpdateEmployee}
            >
              Update
            </button>
          </div>
        </div>
      </div>
      <Popup
        isOpen={noUserOpen}
        onClose={() => (window.location = "/employees")}
        title="Error"
      >
        <div className="flex flex-col gap-6 mt-[30px] mb-[30px]">
          <div className="flex flex-col gap-2">
            <p className="text-sm text-[#142b70]/80 text-left">
              User Not Found!
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-4">
          <button
            onClick={() => (window.location = "/employees")}
            className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
          >
            Ok
          </button>
        </div>
      </Popup>
      <Popup
        isOpen={apiErrorOpen}
        onClose={() => (window.location = "/employees")}
        title="Error"
      >
        <div className="flex flex-col gap-6 mt-[30px] mb-[30px]">
          <div className="flex flex-col gap-2">
            <p className="text-sm text-[#142b70]/80 text-left">
              Something went wrong! Please try again later.
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-4">
          <button
            onClick={() => (window.location = "/employees")}
            className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
          >
            Ok
          </button>
        </div>
      </Popup>
      <ToastContainer />
    </>
  );
};

export default EmployeeDetails;
